export class GrupoFamiliar {
    public id: number;
    public codigoEstudoSocioEconomico: number;
    public respostaQuestionarioGrupoFamiliar: number;
    public nomeMembro: string
}
